// Import controller
import updateAnnouncementCTRL from 'controllers/announcement/updateAnnouncement'

import {fetchAnnouncementList} from './getAnnouncementList'
// Actions
export const START_UPDATE_ANNOUNCEMENT = 'START_UPDATE_ANNOUNCEMENT'
export const SUCCESS_UPDATE_ANNOUNCEMENT = 'SUCCESS_UPDATE_ANNOUNCEMENT'
export const FAILED_UPDATE_ANNOUNCEMENT = 'FAILED_UPDATE_ANNOUNCEMENT'

const schoolId = localStorage.getItem('schoolId')

// Action Creator
export function updateAnnouncement(announcementId, announcementInfo, currentTabState, callback){
  return function(dispatch) {

    dispatch({
      type: START_UPDATE_ANNOUNCEMENT,
      payload: {updating: true, announcementInfo}
    })

    updateAnnouncementCTRL(announcementId, announcementInfo)
    .then((result) => {
      dispatch({
        type: SUCCESS_UPDATE_ANNOUNCEMENT,
        payload: {...result, updating: false}
      })
      if(currentTabState.tabName == 'all'){
        dispatch(fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1}))
      } else if (currentTabState.tabName == 'draft'){
        dispatch(fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'draft'}))
      }else {
        dispatch(fetchAnnouncementList({schoolId: Number(schoolId), param: 'all', amount_per_page: 12, page_number: 1, state: 'published'}))        
      }

      callback()

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_UPDATE_ANNOUNCEMENT,
        payload: err
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/redux/actions/updateAnnouncement.js